import React from 'react';
import { UserProfile } from '../../types/advanced-retirement';
import FormattedInput from '../FormattedInput';

interface PensionSectionProps {
  userProfile: UserProfile;
  handleInputChange: (field: keyof UserProfile, value: any) => void;
}

const PensionSection: React.FC<PensionSectionProps> = ({
  userProfile,
  handleInputChange
}) => {
  return (
    <div className="form-section">
      <h3>Pension Information</h3>
      <div className="form-grid">
        {/* Pension Amount */}
        <div className="form-group full-width">
          <label>Pension Amount</label>
          <div className="side-by-side-inputs">
            <div className="input-group">
              <small>My Pension</small>
              <FormattedInput
                value={userProfile.pensionAmount}
                onChange={(value) => handleInputChange('pensionAmount', value)}
                min={0}
                step={1000}
                formatOptions={{ type: 'currency', decimalPlaces: 0 }}
              />
            </div>
            {userProfile.spouseAge && (
              <div className="input-group">
                <small>Spouse Pension</small>
                <FormattedInput
                  value={userProfile.spousePensionAmount || 0}
                  onChange={(value) => handleInputChange('spousePensionAmount', value)}
                  min={0}
                  step={1000}
                  formatOptions={{ type: 'currency', decimalPlaces: 0 }}
                />
              </div>
            )}
          </div>
        </div>

        {/* Pension Start Age */}
        <div className="form-group full-width">
          <label>Pension Start Age</label>
          <div className="side-by-side-inputs">
            <div className="input-group">
              <small>My Start Age</small>
              <input 
                type="number" 
                value={userProfile.pensionStartAge}
                onChange={(e) => handleInputChange('pensionStartAge', parseInt(e.target.value))}
                min="50" max="85"
              />
            </div>
            {userProfile.spouseAge && (
              <div className="input-group">
                <small>Spouse Start Age</small>
                <input 
                  type="number" 
                  value={userProfile.spousePensionStartAge || 65}
                  onChange={(e) => handleInputChange('spousePensionStartAge', parseInt(e.target.value))}
                  min="50" max="85"
                />
              </div>
            )}
          </div>
        </div>

        {/* Pension Inflation Rate */}
        <div className="form-group full-width">
          <label>Pension Inflation Rate (%)</label>
          <div className="side-by-side-inputs">
            <div className="input-group">
              <small>My Inflation Rate</small>
              <FormattedInput
                value={userProfile.pensionInflationRate}
                onChange={(value) => handleInputChange('pensionInflationRate', value)}
                min={0}
                max={0.1}
                step={0.001}
                formatOptions={{ type: 'percent', decimalPlaces: 2 }}
              />
            </div>
            {userProfile.spouseAge && (
              <div className="input-group">
                <small>Spouse Inflation Rate</small>
                <FormattedInput
                  value={userProfile.spousePensionInflationRate || 0.02}
                  onChange={(value) => handleInputChange('spousePensionInflationRate', value)}
                  min={0}
                  max={0.1}
                  step={0.001}
                  formatOptions={{ type: 'percent', decimalPlaces: 2 }}
                />
              </div>
            )}
          </div>
        </div>

        {/* Pension Survivor Benefit */}
        <div className="form-group full-width">
          <label>Pension Survivor Benefit</label>
          <div className="side-by-side-inputs">
            <div className="input-group">
              <small>My Survivor Benefit</small>
              <div className="checkbox-input-group">
                <input
                  type="checkbox"
                  checked={userProfile.pensionSurvivorBenefitEnabled || false}
                  onChange={(e) => handleInputChange('pensionSurvivorBenefitEnabled', e.target.checked)}
                />
                <label>Enabled</label>
              </div>
            </div>
            {userProfile.spouseAge && (
              <div className="input-group">
                <small>Spouse Survivor Benefit</small>
                <div className="checkbox-input-group">
                  <input
                    type="checkbox"
                    checked={userProfile.spousePensionSurvivorBenefitEnabled || false}
                    onChange={(e) => handleInputChange('spousePensionSurvivorBenefitEnabled', e.target.checked)}
                  />
                  <label>Enabled</label>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PensionSection; 